import _, { find, get, toLower } from 'lodash';
import { Timezones } from '@/@core/utils/timezone';
import countryJsonData from '@/libs/country.json';
import country_cn_temp from '@/libs/country_cn.json';
import country_en_temp from '@/libs/country_en.json';
export function getSelectCountry(lang = 'zh_CN') {
    return _.map(countryJsonData, item => {
        return {
            text: item[lang],
            value: item.id,
        };
    });
}
export function getLocalByCountry(country, lang) {
    const countryItem = find(countryJsonData, {
        id: toLower(country),
    });
    return get(countryItem, lang) || country;
}
export function getSelectTimezone() {
    return _.map(Timezones, item => {
        const { label, value, utc_offset, } = item;
        return {
            text: label,
            value,
            offset: utc_offset,
        };
    });
}
const COUNTRY_CN_MAP = new Map();
const COUNTRY_EN_MAP = new Map();
_.each(country_cn_temp, item => {
    COUNTRY_CN_MAP[item.country] = item.country_name;
});
_.each(country_en_temp, item => {
    COUNTRY_EN_MAP[item.country] = item.country_name;
});
const country_cn = _.map(country_cn_temp, item => {
    const { country, } = item;
    return {
        country,
        name_cn: COUNTRY_CN_MAP[country],
        name_en: COUNTRY_EN_MAP[country],
    };
});
const country_en = _.map(country_en_temp, item => {
    const { country, } = item;
    return {
        country,
        name_cn: COUNTRY_CN_MAP[country],
        name_en: COUNTRY_EN_MAP[country],
    };
});
export { country_cn, country_en, };
